import React, { useEffect, useState } from "react";
import { Col, Tag, Switch, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ImageUploading from "react-images-uploading";
import Select from "react-select";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import HeadingBack from "../component/HeadingBack";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import { AsyncPaginate } from "react-select-async-paginate";
function AddNewsPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const get_main_all_category = useSelector(
    (state) => state?.allapi?.get_main_all_category || []
  );
  const get_sub_sub_category = useSelector(
    (state) => state?.allapi?.get_sub_sub_all_category || []
  );

  const [cateDetail, setCateDetail] = useState({ amenities: [] });
  const [images, setImages] = useState([]);
  const [aboutPage, setAboutPage] = useState("");

  const [maincateList, setMainCateList] = useState([]);
  const [subList, setSubList] = useState([]);
  const [repoterList, setRepoterList] = useState([]);

  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionPr, setSelectedOptionPr] = useState(null);
  const [selectedOptionRp, setSelectedOptionRp] = useState(null);

  const [enabled, setEnabled] = useState(false);
  const [braking, setBraking] = useState(false);
  const [tranding, setTranding] = useState(false);

  const [amenityInput, setAmenityInput] = useState("");

  const maxNumber = 1;
  const API_URl = URL.API_BASE_URL;
  const UPLOAD_ENDPOINT = "publicApi/productcon";

  // -------------------- Dropdowns --------------------
  useEffect(() => {
    const dropList = get_main_all_category.map((data) => ({
      value: data?._id,
      label: data?.name,
    }));
    setMainCateList(dropList);
  }, [get_main_all_category]);

  useEffect(() => {
    if (selectedOptionPr) {
      const filterData = get_sub_sub_category.filter(
        (data) => data?.parentId === selectedOptionPr?.value
      );
      const dropList = filterData.map((data) => ({
        value: data?._id,
        label: data?.name,
      }));
      setSubList(dropList);
    }
  }, [selectedOptionPr, get_sub_sub_category]);

  useEffect(() => {
    const getRepoter = async () => {
      const response = await dispatch(allapiAction.getrepoterAllList({}));
      if (response?.success) {
        const dropList = response?.data?.map((data) => ({
          value: data?._id,
          label: data?.fullName,
        }));
        setRepoterList(dropList);
      }
    };
    getRepoter();
    dispatch(allapiAction.getBlogList(1));
    dispatch(allapiAction.getsubcateAllList({}));
    dispatch(allapiAction.getcateAllList({}));
  }, [dispatch]);

  // -------------------- Image Upload --------------------
  // const onChange = (imageList) => setImages(imageList);
   const onChange = async (imageList, addUpdateIndex) => {
      // data for submit
      // console.log(imageList, addUpdateIndex)
      if (imageList.length > 0) {
        const options = {
          maxSizeMB: 1, // Max 1MB
          maxWidthOrHeight: 800, // Max width/height
          useWebWorker: true, // Faster processing
        };
        const compressedFile = await imageCompression(
          imageList[0]?.file,
          options
        );
        imageList[0].newfile = compressedFile;
      }
      setImages(imageList);
    };

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          loader.file.then((file) => {
            const body = new FormData();
            body.append("upload", file);
            fetch(`${API_URl}/${UPLOAD_ENDPOINT}`, { method: "POST", body })
              .then((res) => res.json())
              .then((res) => resolve({ default: res.url }))
              .catch(reject);
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) =>
      uploadAdapter(loader);
  }

  // -------------------- Amenities --------------------
  const addAmenity = () => {
    const parts = amenityInput
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    if (!parts.length) return;
    setCateDetail((p) => ({
      ...p,
      amenities: [...new Set([...(p.amenities || []), ...parts])],
    }));
    setAmenityInput("");
  };

  const removeAmenity = (v) =>
    setCateDetail((p) => ({
      ...p,
      amenities: p.amenities.filter((x) => x !== v),
    }));

  // -------------------- Save Blog --------------------

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      height: "50px", // Set your desired height here
      minHeight: "50px",
      borderColor: state.isFocused ? "blue" : "grey", // Change border color on focus
      boxShadow: state.isFocused ? "0 0 0 1px blue" : null,
      "&:hover": {
        borderColor: state.isFocused ? "blue" : "grey",
      },
    }),
    input: (provided) => ({
      ...provided,
      height: "50px", // Ensure the input height matches the control height
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "50px", // Ensure the value container height matches the control height
      display: "flex",
      alignItems: "center",
      padding: "0 6px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "50px", // Ensure the indicators container height matches the control height
    }),
  };
   const [stateselect, setstateselect] = useState(null);
  const [districtselect, setdistrictselect] = useState(null);
  console.log(stateselect);
  const [cityselect, setcityselect] = useState(null);

  const [mangeKey, setmangeKey] = useState(0);
  const [mangeKey2, setmangeKey2] = useState(0);

  useEffect(() => {
    setmangeKey(mangeKey + 1);
    setmangeKey2(mangeKey2 + 1);
    setdistrictselect(null);
    setcityselect(null);

    return () => {};
  }, [stateselect]);
  useEffect(() => {
    // setmangeKey(mangeKey + 1);
    setmangeKey2(mangeKey2 + 1);
    setcityselect(null);
    return () => {};
  }, [districtselect]);

  const loadOptionsState = async (search, loadedOptions, pages) => {
    console.log(loadedOptions);
    console.log(pages);
    const response = await fetch(
      URL.API_BASE_URL +
        `/publicApi/searchareaStates?key=${search}&page=${pages?.page}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.State;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: pages?.page + 1,
      },
    };
  };
  const loadOptionsDisrcit = async (search, loadedOptions, pages) => {
    console.log(loadedOptions);
    console.log(pages);
    const response = await fetch(
      URL.API_BASE_URL +
        `/publicApi/searchareaDistricts?key=${search}&page=${pages?.page}&States_id=${stateselect?.State}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.District;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: pages?.page + 1,
      },
    };
  };
  const loadOptionsCity = async (search, loadedOptions, pages) => {
    console.log(loadedOptions);
    console.log(pages);
    const response = await fetch(
      URL.API_BASE_URL +
        `/publicApi/searchareacity?key=${search}&page=${pages?.page}&District_id=${districtselect?.District}`
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.Area + ", " + data?.Pincode;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: pages?.page + 1,
      },
    };
  };
  const handleSave = () => {
    if (!cateDetail?.title) return toast.error("Please enter title");
    if (!images.length) return toast.error("Please select image");
    if (!cateDetail?.short_description)
      return toast.error("Please enter short description");
    if (!selectedOptionPr) return toast.error("Please select category");
    if (!selectedOption) return toast.error("Please select subcategory");

    const data = new FormData();
    data.append("page", 1);
    data.append("title", cateDetail?.title);
    data.append("description", aboutPage);
    data.append("meta_title", cateDetail?.meta_title);
    data.append("categoryId", selectedOptionPr?.value);
    data.append("subcategoryId", selectedOption?.value);
    data.append("repoter_id", selectedOptionRp?.value);
    data.append("areaId", cityselect?._id);
    data.append("districtId", districtselect?._id);
    data.append("stateId", stateselect?._id);
    // cityselect

    // districtselect
    // stateselect
    data.append("publish", enabled ? "Yes" : "No");
    data.append("braking", braking ? "Yes" : "No");
    data.append("tranding", tranding ? "Yes" : "No");
    data.append("meta_description", cateDetail?.meta_description);
    data.append("short_description", cateDetail?.short_description);
    data.append("extraView", cateDetail?.extraView || 0);
    // data.append("feature_image", images[0]?.file);
data.append("feature_image", images[0]?.newfile, images[0]?.file?.name);
    cateDetail.amenities?.forEach((a, idx) => data.append(`tags[${idx}]`, a));

    dispatch(allapiAction.createNews(data, navigate));
  };

  // -------------------- Render Page --------------------
  return (
    <div className="p-4">
      <HeadingBack title="Add News" />

      <Col lg={24} className="mb-4">
        <ImageUploading
          value={images}
          onChange={onChange}
          maxNumber={maxNumber}
          dataURLKey="data_url"
          acceptType={["png", "jpeg", "jpg", "webp"]}
        >
          {({ imageList, onImageUpload, onImageUpdate, onImageRemove }) => (
            <div className="upload__image-wrapper">
              <Button onClick={onImageUpload} type="dashed" block>
                Upload File
              </Button>
              {imageList.map((image, index) => (
                <div key={index} className="image-item mt-2">
                  <img src={image.data_url} alt="" width="100" />
                  <div className="image-item__btn-wrapper mt-1">
                    <button onClick={() => onImageUpdate(index)}>Update</button>
                    <button onClick={() => onImageRemove(index)}>Remove</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </ImageUploading>
      </Col>

      {["title", "short_description", "meta_title", "meta_description"].map(
        (field) => (
          <Col lg={24} key={field} className="mb-3">
            <input
              autoComplete="off"
              className="form-control"
              placeholder={field.replace("_", " ").toUpperCase()}
              name={field}
              value={cateDetail[field]}
              onChange={(e) =>
                setCateDetail({ ...cateDetail, [field]: e.target.value })
              }
            />
          </Col>
        )
      )}
 <Col lg={24}  className="mb-3">
            <input
              autoComplete="off"
              type="number"
              className="form-control"
              placeholder={"Enter View"}
              name={"extraView"}
              value={cateDetail?.extraView}
              onChange={(e) =>
                setCateDetail({ ...cateDetail, [e?.target?.name]: e.target.value })
              }
            />
          </Col>
      <Col lg={24} className="mb-3">
        <Select
          defaultValue={selectedOptionPr}
          onChange={setSelectedOptionPr}
          options={maincateList}
          placeholder="Category"
        />
      </Col>
      <Col lg={24} className="mb-3">
        <Select
          defaultValue={selectedOption}
          onChange={setSelectedOption}
          options={subList}
          placeholder="Sub Category"
        />
      </Col>
      <Col lg={24} className="mb-3">
        <Select
          defaultValue={selectedOptionRp}
          onChange={setSelectedOptionRp}
          options={repoterList}
          placeholder="Reporter"
        />
      </Col>
      <Col lg={24} className="mb-3">
        <AsyncPaginate
              value={stateselect}
              className="liceninput2"
              placeholder="State"
              loadOptions={loadOptionsState}
              onChange={setstateselect}
              style={customStyles}
              additional={{
                page: 1,
              }}
            />
      </Col>
      <Col lg={24} className="mb-3">
        <AsyncPaginate
                key={mangeKey}
                value={districtselect}
                className="liceninput2"
                placeholder="District"
                loadOptions={loadOptionsDisrcit}
                onChange={setdistrictselect}
                additional={{
                  page: 1,
                }}
              />
      </Col>
      <Col lg={24} className="mb-3">
        <AsyncPaginate
                key={mangeKey2}
                value={cityselect}
                className="liceninput2"
                placeholder="City"
                loadOptions={loadOptionsCity}
                onChange={setcityselect}
                additional={{
                  page: 1,
                }}
              />
      </Col>

      <Col lg={24} className="mb-3">
        <div className="flex items-center gap-3">
          <Switch checked={enabled} onChange={setEnabled} />{" "}
          <span>{enabled ? "Publish" : "Unpublish"}</span>
          <Switch checked={braking} onChange={setBraking} />{" "}
          <span>Breaking: {braking ? "Yes" : "No"}</span>
          <Switch checked={tranding} onChange={setTranding} />{" "}
          <span>Trending: {tranding ? "Yes" : "No"}</span>
        </div>
      </Col>

      <Col lg={24} className="mb-3">
        <div className="flex gap-2">
          <input
            value={amenityInput}
            onChange={(e) => setAmenityInput(e.target.value)}
            placeholder="Tags"
          />
          <button onClick={addAmenity}>Add</button>
        </div>
        {cateDetail.amenities.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-2">
            {cateDetail.amenities.map((a) => (
              <Tag key={a} closable onClose={() => removeAmenity(a)}>
                {a}
              </Tag>
            ))}
          </div>
        )}
      </Col>

      <Col lg={24} className="mb-3">
        <CKEditor
          editor={Editor}
          data={aboutPage}
          onChange={(e, editor) => setAboutPage(editor.getData())}
          config={{ extraPlugins: [uploadPlugin] }}
        />
      </Col>

      <Button type="primary" onClick={handleSave} block className="mt-4">
        Save News
      </Button>
    </div>
  );
}

export default AddNewsPage;
